var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16666 3.33325H3.33332C2.8913 3.33325 2.46737 3.50885 2.15481 3.82141C1.84225 4.13397 1.66666 4.55789 1.66666 4.99992V16.6666C1.66666 17.1086 1.84225 17.5325 2.15481 17.8451C2.46737 18.1577 2.8913 18.3333 3.33332 18.3333H15C15.442 18.3333 15.8659 18.1577 16.1785 17.8451C16.4911 17.5325 16.6667 17.1086 16.6667 16.6666V10.8333",
    stroke: "#70B8FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 2.08344C15.7482 1.75192 16.1978 1.56567 16.6667 1.56567C17.1355 1.56567 17.5851 1.75192 17.9167 2.08344C18.2482 2.41496 18.4344 2.8646 18.4344 3.33344C18.4344 3.80228 18.2482 4.25192 17.9167 4.58344L9.99999 12.5001L6.66666 13.3334L7.49999 10.0001L15.4167 2.08344Z",
    stroke: "#70B8FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1);
export default __webpack_public_path__ + "static/media/edit 1.b17f6cdbf75465e7b9bf8d3915d03085.svg";
export { ForwardRef as ReactComponent };